<template>
    <div>
        <NavMenu/>
        <div style="background: rgba(68, 141, 247, 0.08);">
            <div class="crumbsBox">
                <div>
                    您当前所在位置：
                    <span class="fatherMenu" @click="goFatherMenuFn">{{!currentMenu?'首页':currentMenu}}</span>-
                    <span class="childMenu" @click="goChildMenuFn" v-if="childMenu">{{childMenu.title}}-</span>
                    <span>新闻详情</span>
                </div>
            </div>
        </div>
        <div class="NewsDetailWarp">
            <div class="detail-newsTitle">{{newsDetailObj.pressTopic }}</div>
            <div class="centerbox">
                <div class="newtopbox">
                    <div class="time">
                        <i class="el-icon-date"></i>{{newsDetailObj.pressTime | timer}}</div>
                    <div v-if="newsDetailObj.pressSource">来源:{{newsDetailObj.pressSource}}</div>
                </div>
                <div class="detail-newscontent">
                    <div v-html="newsDetailObj.content"></div>
                    <div v-if="newsDetailObj.pressTypeName=='第三方培训'&&newsDetailObj.interlinkageUrl" class="seeDetailbox">
                        <a :href="newsDetailObj.interlinkageUrl" target="_blank"> 查看详情</a>
                    </div>
                    <div class="filebox" v-if="documentList.length!=0">
                        附件：
                        <div v-for="(item,index) in documentList" :key="index" class="file" @click="downloadDOCfN(item)">
                            {{item.name}}
                        </div>
                    </div>
                </div>
            </div>
            <!-- <div class="other-news-box">
                <div class="other-news">
                    <div v-if="newsDetailObj.newsLast" @click="lastNewsFn(newsDetailObj.newsLast.pressId)">
                        上一篇：{{ newsDetailObj.newsLast.pressTopic }}
                    </div>
                    <div v-if="newsDetailObj.newsNext" @click="nextNewsFn(newsDetailObj.newsNext.pressId)">
                        下一篇：{{ newsDetailObj.newsNext.pressTopic }}
                    </div>
                </div>
                <div @click="returnPage" class="return-box">【返回列表】</div>
            </div> -->
            <ReturnTop />
            <div @click="returnPage" class="return-box">返回
                <i class="el-icon-caret-right" /> </div>
        </div>
        <div class="footerbox">
            <Footer/>
        </div>
    </div>
</template>
<script>
import NavMenu from '@/components/navMenu.vue'
import Footer from '@/components/footer.vue'
import ReturnTop from "@/components/returnTop.vue";
import { httpService, srcUrl } from "@/service/httpService";
export default {
    components: {
        NavMenu,
        Footer,
        ReturnTop
    },
    data() {
        return {
            srcUrl: srcUrl,
            newsDetailObj: {},
            documentList: [],
            currentMenu: sessionStorage.getItem('clickMenu'),
            childMenu: null,
            fatherlinkUrl: sessionStorage.getItem('fatherlinkUrl'),
            type: "",
        }
    },
    mounted() {
        let data = JSON.parse(sessionStorage.getItem('childMenuObj'))
        if (data) {
            this.childMenu = data
        }
        else {
            this.childMenu = JSON.parse(sessionStorage.getItem('currentNew'))
            // if (this.currentMenu == '新闻中心') {
            //     this.childMenu = {
            //         title: "通知公告",
            //         id: "51",
            //         linkUrl: "/news-secondpage/notice",
            //     }
            // } else if (this.currentMenu == '党建工作') {
            //     this.childMenu = {
            //         title: "党建引领",
            //         id: "61",
            //         linkUrl: "/party-secondpage/party-leads",
            //     }
            // }else if (this.currentMenu == '行业服务') {
            //     this.childMenu = {
            //          title: "团标建设",
            //   id: "41",
            //   linkUrl: "/industry-secondpage/mark-build",
            //     }
            // }
        }
        let id = this.$route.query.id || this.$route.params.id;
        this.type = this.$route.query.type
        this.getnewsdetail(id);
    },
    methods: {
        async getnewsdetail(id) {
            // let data
            // if (this.type==1) {
            let data = await httpService.getNewsDetails(id);
            // }else{
            //     data = await httpService.getConferee(id);
            // }
            if (data.code == "200") {
                this.newsDetailObj = data.result;
                document.body.scrollTop = 0;
                document.documentElement.scrollTop = 0;
                if (data.result.downloadAttachment) {
                    let doclist = data.result.downloadAttachment.split(",")
                    doclist = doclist.map((url, index) => {
                        return {
                            url: srcUrl + url,
                            uid: index,
                            name: url,
                        }
                    })
                    this.documentList = doclist
                }
            } else {
                this.$message.error(data.message);
            }
        },
        returnPage() {
            let currentNew = JSON.parse(sessionStorage.getItem('currentNew'))
            if (currentNew) {
                this.$router.push(currentNew.menuurl);
            } else {
                this.$router.go(-1)
            }
        },
        downloadDOCfN(data) {
            let Docurl = `${process.env.VUE_APP_GATEWAY}${'/upload/download?session='}${data.name}`
            window.open(Docurl)
        },
        goFatherMenuFn() {
            if (this.fatherlinkUrl) {
                this.$router.push(this.fatherlinkUrl);
            } else {
                this.$router.push('/');
            }
        },
        goChildMenuFn() {
            if (this.childMenu) {
                this.$router.push(this.childMenu.linkUrl || this.childMenu.menuurl);
            }
        },
    },
    filters: {
        timer: (value) => {
            if (value) {
                return value.substring(0, 10);
            }
        },
    },
}
</script>
<style lang="less" scoped>
.crumbsBox {
	// width: 100%;
	width: 1200px;
	margin: 0 auto;
	background: rgba(68, 141, 247, 0.03);
	padding: 19px 0 19px 0px;
	color: #333;
	.fatherMenu {
		cursor: pointer;
		&:hover {
			color: #448df7;
		}
	}
	.childMenu {
		cursor: pointer;
		&:hover {
			color: #448df7;
		}
	}
}
.NewsDetailWarp {
	padding: 50px 0 0 0;
	.detail-newsTitle {
		width: 1100px;
		margin: 0 auto;
		font-size: 26px;
		font-weight: bold;
		line-height: 35px;
		color: #333333;
		text-align: center;
		position: relative;
		border-bottom: 1px solid #dddddd;
		padding-bottom: 10px;
	}
	.detail-newsTitle::before {
		content: '';
		position: absolute;
		width: 68px;
		height: 0px;
		border: 2px solid #448df7;
		opacity: 1;
		background: #448df7;
		left: 50%;
		transform: translateX(-50%);
		top: 95%;
	}

	.centerbox {
		width: 1000px;
		margin: 0 auto;

		.newtopbox {
			display: flex;
			flex-direction: row;
			justify-content: space-between;
			align-items: center;
			color: #666;
		}
		.time {
			margin: 20px 0 20px 0;
			line-height: 30px;
			color: #cacaca;
		}
		.detail-newscontent {
			position: relative;
			.seeDetailbox {
				position: absolute;
				top: 330px;
				left: 150px;
				font-size: 14px;

				cursor: pointer;
				a {
					color: #fff;
				}
			}
			min-height: 400px;
			/deep/img {
				width: 100%;
			}
			/deep/p {
				width: 100%;
				word-wrap: break-word;
				// line-height: 30px;
			}
			.filebox {
				width: 100%;
				margin: 0 auto 40px auto;
				padding: 0 0 0 0px;
				box-sizing: border-box;
				font-size: 16px;
				font-weight: bold;
				line-height: 30px;
				margin-top: 40px;
				.file {
					font-size: 16px;
					font-weight: 400;
					// line-height: 30px;
					color: #666;
					cursor: pointer;
					&:hover {
						color: #1088fe;
					}
				}
			}
		}
	}
	.return-box {
		width: 1000px;
		margin: 0 auto;

		text-align: right;
		padding-bottom: 10px;
		// padding-right: 290px;
		border-bottom: 1px dashed #dddddd;
		color: #448df7;
		font-size: 16px;
		cursor: pointer;
	}
}
</style>


